/** @format */

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from '@dcsg-ngx-ecommerce/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { HOME_CONSTANTS } from '../../app.constants';
import { IStory } from '../story/story.interface';

@Component({
	selector: 'home-story-carousel',
	templateUrl: './carousel.component.html',
	styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
	@Input() data: IStory[];
	@Input() addlData: any;

	selector: string;
	paused = false;
	invervalTime = 5000;
	public isGGStaticPage: boolean;
	public ggStaticColors = HOME_CONSTANTS.ggStaticColors;
	@ViewChild('carousel', { static: true }) carousel: NgbCarousel;

	constructor(private utilityService: UtilityService) {}

	ngOnInit() {
		this.isGGStaticPage = this.utilityService.ggStaticPage(this.addlData.isStaticPage);
	}

	togglePaused() {
		this.paused ? (this.invervalTime = 5000) : (this.invervalTime = 0);
		this.paused = !this.paused;
	}

	isCarousel() {
		return this.data.length > 1 && this.data[0].textBoxPosition;
	}
}
